import WebcamPanel from "./webcamPanel.container";

export default WebcamPanel;
